<template>
    <div>
        <b-card no-body>
        <div class="row p-2 align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Ay</label>
                <v-select-list :options="months" v-model="month" placeholder="Ay" ></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Yıl</label>
                <v-select-list :options="years" v-model="year" placeholder="Yıl" ></v-select-list>
            </div>
        </div>
        <div class="row mb-1">
            <div class="ml-2  mr-2">
                <v-executer :loading="filterLoading" :action="getReport">Filtrele</v-executer>
            </div>
            <div class="d-flex  justify-content-end">
                <v-executer :loading="filterLoading" :variant="success" :action="exportReport">Excel'e Aktar</v-executer>
            </div>
        </div>
        <b-card class="mt-1" body-class="p-75" >
        <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1">
                        <thead>
                            <tr>
                                <th class="text-nowrap w-10">Plasiyer</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in reportData" >
                                <tr :key="ps.PlasiyerFullName">
                                    
                                    <td class="text-nowrap">{{$safe(ps,'PlasiyerFullName') || '-'}}</td>
                                 </tr>
                                <tr :key="ps.CustomerCode + '-dl'" v-if="ps.ReportItems">
                                    <td colspan="20">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-16">Cari Kodu</th>
                                                    <th class="text-nowrap w-20">Cari Adı</th>
                                                    <th class="text-nowrap w-16">Tarih</th>
                                                    <th class="text-nowrap w-16">Tutar</th>
                                                    <th class="text-nowrap w-16">Ödenen Tutar</th>
                                                    <th class="text-nowrap w-16">Taksit</th>
                                                    <th class="text-nowrap w-16">Açıklama</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="dl in ps.ReportItems" :key="dl.CustomerCode">
                                                        <td class="text-nowrap">{{$safe(dl,'CustomerCode') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'CustomerName') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'CreateTime') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'Amount') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'PaidPart') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'Installment') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(dl,'Description') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="reportData.length == 0">
                                <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
       
    </b-card>
</b-card>
    </div>
  
      
</template>
<script>
import { NetsisApi } from '@/api/netsis'
import  {PaymentApi} from '@/api/payment'
import {UserApi} from '@/api/user'
import { BCard, BCardText, BLink,BImg,BOverlay,BSpinner } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    components:{
        BCard
    },
    data(){
        return{
            filterLoading:false,
            months:[],
            reportData:[],
            month:1,
            years:[
                2023,
                2024,
                2025
            ]
        }
    },
    mounted(){
        this.getMonths()
    },
    methods:{
        exportReport(){
            this.getReport()
            this.filterLoading = true
           
           PaymentApi.GetFaturasizOdemeTalebiReportExcel(this.month,this.year).then(res => {
               this.filterLoading = false
               this.$result(res)
           }).catch(err=>{
               this.filterLoading = false
           })
        },
        getReport(){
            this.filterLoading = true
           
            PaymentApi.GetFaturasizOdemeTalebiReport(this.month,this.year).then(res => {
                this.filterLoading = false
                this.reportData = res.data.Data
            }).catch(err=>{
                this.filterLoading = false
            })
        },
        getMonths(){
            for (let index = 1; index <= 12; index++) {
                this.months.push(index)
                
            }
        }

    },
    computed:{
        
    }


}


</script>